import { LoadingScreen } from "@rosc/ui/v32/loading-screen";
import type { JSX } from "react";
import { V3Logo } from "./logo";

// A full-screen v3.2 wait (EMR launch): @rosc/ui's LoadingScreen with the
// ROSC mark.
export const V3LoadingScreen = ({
  label,
  className,
}: {
  label: string;
  className?: string;
}): JSX.Element => (
  <LoadingScreen
    className={className}
    label={label}
    mark={<V3Logo size={40} wordmark={false} />}
  />
);
